import key from './key'

const actionTypes = {
  SET_DEVICE: `${key}/SET_DEVICE`
}

export default actionTypes
